<template>
  <v-dialog
    :model-value="modelValue"
    max-width="400"
    @click:outside="$emit('close')"
  >
    <v-card>
      <v-card-title class="pt-4">Import {{ text }}</v-card-title>
      <v-card-text class="pt-0 pl-4">
        <v-select
          color="primary"
          label="Schematisation stage to import from"
          :items="schematisationStages"
          v-model="schematisationStageIdToImport"
          item-title="stage_configuration.name"
          item-value="id"
          filled
        />
        The current {{ text }} will be replaced by imported {{ text }}.
        <br><br>
        Are you sure you want to continue?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="loading"
          :disabled="!schematisationStageIdToImport"
          @click="onImportButtonClicked"
          color="primary"
          text
        >
          Import
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "ImportFromPreviousStageDialog",
    props: {
      modelValue: { required: true },
      schematisationStages: { default: [] },
      text: { required: true },
      loading: { default: false }
    },
    data: () => ({
      schematisationStageIdToImport: null
    }),
    methods: {
      onImportButtonClicked () {
        if (this.schematisationStageIdToImport) {
          this.$emit("import", this.schematisationStageIdToImport)
        }
      }
    },
    emits: ["import", "close"]
  }
</script>
